import Surveys from '../components/Surveys'

const Home = () => (
    <div className='sjs-client-app__content--surveys-list'>
        <h1>My Surveys</h1>
        <Surveys/>
    </div>
)

export default Home;